import _ from 'lodash';
import React from 'react';
import Button from 'src/@vymo/ui/atoms/button';
import classnames from 'classnames';
import { ReactComponent as Cross } from 'src/assets/icons/close.svg';
import { getIconForVariant } from './queries';
import styles from './index.module.scss';

export type HeaderProps = {
  children?: string | React.ReactNode;
  'data-test-id'?: string;
  className?: string;
  onClose?: () => void;
  showHeaderCloseButton?: boolean;
  variant?: 'default' | 'success' | 'error' | 'info' | 'warning';
};

function Header({
  children,
  'data-test-id': dataTestId,
  className = '',
  onClose = _.noop,
  showHeaderCloseButton = false,
  variant = 'default',
}: React.PropsWithChildren<HeaderProps>) {
  const iconClassNames = classnames(
    styles.modal__header__icon,
    styles[`modal__header__icon__${variant}`],
  );
  return (
    <div
      data-test-id={`${dataTestId}`}
      className={`${styles.modal__header} ${className}`}
    >
      <div className={`${styles.modal__header__info}`}>
        {variant !== 'default' && (
          <div className={iconClassNames} id="variant-icon">
            {getIconForVariant(variant)}
          </div>
        )}
        <div className={`${styles.modal__header__content}`}>{children}</div>
      </div>
      {showHeaderCloseButton && (
        <Button
          data-test-id={`${dataTestId}-close-button`}
          size="small"
          type="text"
          iconProps={{ icon: <Cross />, iconPosition: 'right' }}
          onClick={onClose}
        />
      )}
    </div>
  );
}

export default Header;
